module.exports = __webpack_public_path__ + "media/images/logos/facebook-c5520bb732a8e0c52a2235a46ad114f2.svg";